import type { ButtonProps } from '@hover/blueprint';
import { Icon } from '@hover/blueprint';
import { iconInspiration } from '@hover/icons';
import React from 'react';
import { useHistory } from 'react-router';

import { imageTracking } from 'src/modules/homeownerApp/components/Customize/tracking';
import { getStylesRoute } from 'src/modules/homeownerApp/components/Projects/Project/helpers';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { Button } from 'src/shared/components';
import type { AiDisplayImage, Maybe } from 'src/shared/graphql/generated';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { useTrackingMetadata } from 'src/shared/hooks/useSegmentHistory';
import type { OptionalTrackingProperties } from 'src/shared/hooks/useTracking';

interface ProjectStylesButtonProps extends ButtonProps {
  generatedImage: Maybe<AiDisplayImage>;
  projectId: string;
}

export const ProjectStylesButton = ({
  generatedImage,
  projectId,
  ...props
}: ProjectStylesButtonProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { trackingData: contextTrackingData } = useHomeownerAppContext();
  const {
    metadata: { partner_id: partnerId },
  } = useTrackingMetadata();
  const history = useHistory();

  const augmentedTrackingData: OptionalTrackingProperties = {
    ...contextTrackingData,
    ...imageTracking(generatedImage),
    button_text: 'sparkles-icon',
    partner_id: partnerId,
    project_id: Number(projectId),
    primary_cta: false,
    space_type: generatedImage?.spaceType ?? undefined,
    track_id: 'styles-button-project-page',
    view_type: 'carousel-view',
  };

  const handleStylesClick = () => {
    if (!generatedImage?.aiOriginalImageId) return;

    history.push(getStylesRoute(generatedImage, projectId));
  };

  return (
    <Button
      colorMode="dark"
      includeTrackingImpression
      label={t('projects.edit.styles')}
      onClick={handleStylesClick}
      optionalTrackingProperties={augmentedTrackingData}
      shape="circle"
      variant="glass"
      {...props}
    >
      <Icon icon={iconInspiration} />
    </Button>
  );
};
